<template>
  <el-dialog
    title="详情"
    :visible.sync="detailDialogVisible"
    @close="handleCloseDetail"
    width="1050px"
    center
    top="10vh">
    <div class="detail" v-loading="detailDialogLoading">
      <div class="baseInfo">
        <div class="baseInfoTitle">
          <div class="line" />
          <span>调配信息</span>
        </div>
        <div class="baseInfoContent">
          <div class="baseInfoContentItem">
            <span class="span1">供应商名称：</span>
            <span>{{ detailData.fleetName }}</span>
          </div>
          <div class="baseInfoContentItem mb0">
            <span class="span1">起运地址：</span>
            <span>{{ detailData.startName }}</span>
            <span v-if="detailData.startType === 1">【{{ detailData.startPortName }}】</span>
            <div class="addressItem">{{ detailData.startDetail }}</div>
          </div>
          <div class="baseInfoContentItem mb0">
            <span class="span1">交车地址：</span>
            <span>{{ detailData.deliveryName }}</span>
            <span v-if="detailData.deliveryType === 1">【{{ detailData.deliveryPortName }}】</span>
            <div class="addressItem">{{ detailData.deliveryDetail }}</div>
          </div>
          <div class="baseInfoContentItem">
            <span class="span1">卸车统计：</span>
            <span>{{ detailData.deliveryPlace }}</span>
          </div>
          <div class="baseInfoContentItem specialItem">
            <div class="specialOne">
              <span class="span1">装车时间：</span>
              <span>{{ detailData.entruckTime }}</span>
            </div>
            <div>
              <span class="span1">完成时间：</span>
              <span>{{ detailData.fulfilTime }}</span>
            </div>
          </div>
          <div class="baseInfoContentItem specialItem">
            <div class="specialOne">
              <span class="span1">预装车数量：</span>
              <span>{{ convert0(1, 1, detailData.fleetCount) }}</span>
            </div>
            <div>
              <span class="span1">已装车数量：</span>
              <span>{{ convert0(1, 1, detailData.surplusCount) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="operation">
        <div class="operationTitle">
          <div class="line" />
          <span>运输车信息</span>
        </div>
        <div class="operationTable">
          <el-table :data="driverData" border class="w100">
            <el-table-column label="序号" align="center" width="50px" type="index" />
            <el-table-column prop="truckName" label="车牌号" align="center" />
            <el-table-column prop="driverName" label="司机姓名" align="center" />
            <el-table-column prop="driverTel" label="司机电话" align="center" />
            <el-table-column prop="fleetCount" label="运输数量" align="center" />
            <el-table-column
              prop="entruckDate"
              :formatter="getDate"
              label="装车时间"
              align="center" />
            <el-table-column
              prop="transportDate"
              :formatter="getDate"
              label="发车时间"
              align="center" />
            <el-table-column
              prop="deliveryDate"
              :formatter="getDate"
              label="交车时间"
              align="center" />
            <el-table-column prop="isBoard" label="是否换板" align="center">
              <div slot-scope="scope">{{ scope.row.isBoard === 1 ? '是' : '否' }}</div>
            </el-table-column>
            <el-table-column label="车辆状态" align="center">
              <div slot-scope="scope">{{ getCarState2(scope.row.status) }}</div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="operation mt15">
        <div class="operationTitle">
          <div class="line" />
          <span>委托车信息</span>
        </div>
        <div class="operationTable">
          <div class="nav">
            <div class="navContainer w160">
              <p class="font-size-8">批次号：</p>
              <el-input
                v-model="queryForm.batchNumber"
                size="mini"
                class="w135"
                placeholder="输入批次号" />
            </div>
            <div class="navContainer w160">
              <p class="font-size-8">运单号：</p>
              <el-input
                v-model="queryForm.waybillNo"
                size="mini"
                class="w135"
                placeholder="输入运单号" />
            </div>
            <div class="navContainer w160">
              <p class="font-size-8">车架号：</p>
              <el-input
                v-model="queryForm.frameNumber"
                size="mini"
                class="w135"
                placeholder="输入车架号"
                @paste.native.capture.prevent="
                  value => {
                    return searchCopyFormat(value);
                  }
                " />
            </div>
            <div class="navContainer w160">
              <p class="font-size-8">品牌：</p>
              <el-input v-model="queryForm.brand" size="mini" class="w135" placeholder="输入品牌" />
            </div>
            <div class="navContainer w160">
              <p class="font-size-8">是否质损：</p>
              <el-select
                v-model="queryForm.isMassLoss"
                class="w135"
                size="mini"
                filterable
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="navContainer w160">
              <p class="font-size-8">状态：</p>
              <el-select
                v-model="queryForm.state"
                class="w125"
                size="mini"
                filterable
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in optionsState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="navBtn">
              <el-button size="small" class="searchBtn" @click="carPageList">查询</el-button>
              <el-button size="small" class="resetBtn" @click="resetCar">重置</el-button>
              <el-button size="small" type="primary" @click="exportClick">导出</el-button>
              <el-button size="small" type="primary" @click="onClickEditSupplier" class="yellow-bg"
                >修改供应商</el-button
              >
            </div>
          </div>
          <el-table
            ref="multipleTable"
            :data="carData"
            :row-key="(item) => item.id"
            border
            class="w100"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="60" align="center" :reserve-selection="true" />
            <el-table-column prop="batchNumber" label="批次号" width="110" align="center" />
            <el-table-column prop="supplierName" label="实际供应商" width="110" align="center" />
            <el-table-column prop="waybillNo" label="运单编号" width="110" align="center" />
            <el-table-column prop="frameNumber" label="车架号" min-width="130" align="center" />
            <el-table-column prop="brand" label="品牌" align="center" />
            <el-table-column label="起始地" align="center" :formatter="originFormat" />
            <el-table-column label="交车地" align="center" :formatter="deliveryPlaceFormat" />
            <el-table-column prop="model" label="型号" align="center" />
            <el-table-column prop="personnelName" label="运输车牌号" align="center" />
            <el-table-column prop="loadingDate" label="装车时间" min-width="130" align="center">
              <div slot-scope="scope">{{ getTimeOne(scope.row.loadingDate, scope.row.state) }}</div>
            </el-table-column>
            <el-table-column prop="deliveryDate" label="交车时间" min-width="130" align="center">
              <div slot-scope="scope">{{ getTime(scope.row.deliveryDate, scope.row.state) }}</div>
            </el-table-column>
            <el-table-column prop="isMassLoss" label="是否质损" min-width="60" align="center">
              <div slot-scope="scope">{{ scope.row.isMassLoss === 1 ? '是' : '否' }}</div>
            </el-table-column>
            <el-table-column prop="state" label="状态" min-width="60" align="center">
              <div slot-scope="scope">{{ getCarState1(scope.row.state) }}</div>
            </el-table-column>
          </el-table>
          <div class="paginationContainer mt10">
            <span>共{{ total }}条</span>
            <el-pagination
              background
              small
              :page-sizes="[10, 50, 100, 200, 500]"
              layout="sizes,prev, pager, next,jumper"
              :total="total"
              :current-page.sync="queryForm.page"
              @size-change="detailSizeChange"
              @current-change="detailChange"
              @prev-click="detailChange"
              @next-click="detailChange" />
          </div>
        </div>
      </div>
      <div class="operation">
        <div class="operationTitle">
          <div class="line" />
          <span>操作记录</span>
        </div>
        <div class="operationTable">
          <el-table :data="operationData" border class="w100">
            <el-table-column prop="createTime" label="操作时间" align="center">
              <div slot-scope="scope">{{ getTime(scope.row.createTime) }}</div>
            </el-table-column>
            <el-table-column prop="operateType" label="操作类型" align="center" />
            <el-table-column prop="operationName" label="操作人" align="center" />
            <el-table-column prop="remark" label="备注" align="center" />
          </el-table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  // import { nextTick } from 'vue';
  import { vehicleDeployFleetCvDetail, vehicleDetailPageList } from '@/service/vehiclelog';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    name: 'carInfo',
    data() {
      return {
        detailDialogVisible: false,
        detailDialogLoading: false,
        multipleSelection: [],
        detailData: {},
        driverData: [], // 托运车信息
        carData: [], // 委托车信息
        operationData: [],
        basicId: '',
        total: 0,
        queryForm: {
          basicId: '',
          rows: 10,
          page: 1,
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brand: '',
          shipCabinName: '',
          startPortName: '',
          deliveryPortName: '',
          isMassLoss: '',
          state: '',
        },
        defaultForm: {},
        options: [
          {
            value: '0',
            label: '否',
          },
          {
            value: '1',
            label: '是',
          },
        ],
        optionsState: [
          {
            value: '0',
            label: '待装车',
          },
          {
            value: '1',
            label: '已装船',
          },
          {
            value: '2',
            label: '已交车',
          },
          {
            value: '-1',
            label: '已取消',
          },
        ],
      };
    },
    computed: {
      getTimeOne() {
        return function (time, type) {
          if (type != 0 && type != undefined) {
            return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
          } else {
            return null;
          }
        };
      },
      getTime() {
        return function (time, type) {
          if (type == 2 || (time != null && time != undefined && type == undefined)) {
            return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
          } else {
            return null;
          }
        };
      },
      getCarState1() {
        return function (state) {
          switch (state) {
            case 0:
              return '待装车';
            case 1:
              return '已装车';
            case 2:
              return '已交车';
            case -1:
              return '已取消';
          }
        };
      },
      getCarState2() {
        return function (state) {
          switch (state) {
            case 0:
              return ':待开始';
            case 1:
              return '运输中';
            case 2:
              return '已交车';
            case 5:
              return '装车中';
          }
        };
      },
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.queryForm));
    },
    methods: {
      handleCloseDetail() {
        this.$refs.multipleTable.clearSelection();
      },
      onClickEditSupplier() {
        const ids = this.multipleSelection.map(item => item.id).join(',');
        this.$emit('openDialgEditSupplier', ids);
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 格式化起始地
      originFormat(row) {
        return row.startPortName ? row.startPortName : row.startName;
      },
      // 格式化起始地
      deliveryPlaceFormat(row) {
        return row.deliveryPortName ? row.deliveryPortName : row.deliveryName;
      },
      searchCopyFormat(value) {
        let splitArr = value.clipboardData.getData('Text').replace(/\s/g, ',').split(',');
        splitArr = splitArr.filter(item => item);
        splitArr =
          splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        this.queryForm.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
      },
      async showData() {
        this.multipleSelection = [];
        // this.detailDialogVisible = true;
        // await nextTick();
        // console.log(nextTick);
        // this.$refs.multipleTable.clearSelection();

        this.detailDialogLoading = true;
        // this.basicId = id;
        // this.queryForm.basicId = id;
        this.queryForm.page = 1;
        const { status, message, data } = await vehicleDeployFleetCvDetail(this.basicId);
        if (status !== 0) return this.$message.error(message);
        this.detailData = data;
        this.driverData = data.driverList;
        this.operationData = data.operateRecordList;
        await this.carPageList();
        this.$refs.multipleTable.clearSelection();
        this.detailDialogLoading = false;
      },
      async openDialog(id) {
        this.multipleSelection = [];
        this.detailDialogVisible = true;
        // await nextTick();
        // console.log(nextTick);
        // this.$refs.multipleTable.clearSelection();

        this.detailDialogLoading = true;
        this.basicId = id;
        this.queryForm.basicId = id;
        this.queryForm.page = 1;
        const { status, message, data } = await vehicleDeployFleetCvDetail(id);
        if (status !== 0) return this.$message.error(message);
        this.detailData = data;
        this.driverData = data.driverList;
        this.operationData = data.operateRecordList;
        await this.carPageList();
        this.detailDialogLoading = false;
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
        });
      },
      // 将null转换为0
      convert0(row, column, cellValue) {
        if (cellValue) {
          return cellValue;
        } else {
          return '0';
        }
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      // 弹出框分页查询
      async carPageList() {
        const {
          message,
          status,
          data: { records, total },
        } = await vehicleDetailPageList(this.queryForm);
        if (status !== 0) return this.$message.error(message);
        
        this.total = total;
        console.log(records);
        this.carData = records;
      },
      // 详情 —— 分页大小改变
      detailSizeChange(size) {
        // 每页条数
        this.queryForm.rows = size;
        this.carPageList();
      },
      // 详情 —— 当前页改变
      detailChange(page) {
        // 翻页
        this.queryForm.page = page;
        this.carPageList();
      },
      // 重置
      resetCar() {
        this.queryForm = JSON.parse(JSON.stringify(this.defaultForm));
        this.queryForm.basicId = this.basicId;
      },
      // 导出
      exportClick() {
        let token = getSessionStore('token');
        let url = baseUrl + '/platform/vehicleDeployCar/carExport';
        url += '?basicId=' + this.basicId + '&batchNumber=' + this.queryForm.batchNumber;
        url +=
          '&waybillNo=' + this.queryForm.waybillNo + '&frameNumber=' + this.queryForm.frameNumber;
        url += '&brand=' + this.queryForm.brand + '&shipCabinName=' + this.queryForm.shipCabinName;
        url +=
          '&startPortName=' +
          this.queryForm.startPortName +
          '&deliveryPortName=' +
          this.queryForm.deliveryPortName;
        url += '&isMassLoss=' + this.queryForm.isMassLoss + '&state=' + this.queryForm.state;
        url += '&access_token=' + token;
        window.location.href = url;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .detail {
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height: 80vh;
    overflow: auto;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;

        .addressItem {
          font-size: 12px;
          color: rgba(153, 153, 153, 1);
          margin-bottom: 10px;
          margin-left: 70px;
        }

        &Item {
          margin-bottom: 10px;

          .span1 {
            font-weight: 700;
          }

          span {
            font-size: 14px;
          }

          .specialOne {
            width: 50%;
          }
        }

        .specialItem {
          display: flex;
        }
      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      ::v-deep {
        .el-table td,
        .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }

  .navContainer p {
    display: inline-block;
    width: 85px;
    text-align: right;
  }
  ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
    color: #606266;
    content: '全选';
    font-size: 12px;
    margin-left: 2px;
  }
</style>
